var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page-options-list',{attrs:{"options":_vm.filteredOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }